import Layout from '@/layouts/EmptyLayout'
export default [{
    path: '/myTake',
    name: 'myTake',
    props: true,
    meta: {
      layout: 'main'
    },
  component: () => import('@/views/myTake/index')
    
  }]
